module.exports = __webpack_public_path__ + "1cccf0beb8e54bda016cd9a5ca665f6d.jpg";